import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from '@gemini/core';
export const Image = ({ priority, fill, style, ...props }) => {
    const fillStyle = fill
        ? {
            position: 'absolute',
            height: '100%',
            width: '100%',
            left: '0',
            top: '0',
            right: '0',
            bottom: '0',
        }
        : undefined;
    return (_jsx(Box, { as: "img", loading: priority ? 'eager' : 'lazy', decoding: "async", ...style, ...fillStyle, ...props }));
};
